import { Injectable, inject, signal } from '@angular/core';
import { ProjectDataService } from '../../../state-and-data-handling/project-data.service';
import { ExpenditureEntryService } from '../project-calculation-form/services/expenditure-entry.service';
import { ProjectTaskService } from '../../services/project-task.service';
import { assert } from '../../../../../../core/assert/assert';
import { ProjectTaskGridRow } from '../../../../shared/project-detail-types';
import { ExpenditureRateEntry } from '../../../../../../core/models/project/project-expenditure-entry.model';

// Provide in ProjectTaskGrid so that the instance is correctly re-created.
@Injectable({ providedIn: 'root' })
export class ProjectTaskGridService {
  // Grid data
  public gridData = signal<ProjectTaskGridRow[]>([]);
  // DI
  private readonly projectTaskService = inject(ProjectTaskService);
  private readonly projectDataService = inject(ProjectDataService);
  private readonly expenditureEntryService = inject(ExpenditureEntryService);

  public openNewExpenditureRateDialog(
    taskGridRow: ProjectTaskGridRow,
    applyResult: (entries: ExpenditureRateEntry[]) => void,
  ): void {
    this.expenditureEntryService.openNewExpenditureRateDialog(
      taskGridRow.expenditureRateHistory,
      (entries) => applyResult(entries),
    );
  }

  public createEmptyTaskGridDRow(): ProjectTaskGridRow {
    return {
      task: null,
      budgetSeconds: 0,
      budgetMonetary: 0,
      expenditureRateHistory: [
        this.expenditureEntryService.createExpenditureEntry(
          0,
          this.projectDataService.getProjectClone().startsAt,
          0,
        ),
      ],
    };
  }

  public removeTaskGridRow(taskGridRow: ProjectTaskGridRow): void {
    // Remove
    const index = this.gridData().findIndex((row) => row.task.id === taskGridRow.task.id);
    assert(index >= 0, 'Project task grid row could not be found.');
    this.gridData().splice(index, 1);

    // Sync
    this.projectTaskService.syncProjectModel(
      this.gridData(),
      this.projectDataService.getProjectClone(),
    );
    this.projectDataService.userOperationConducted$.next(true);
  }

  public deleteGridData(): void {
    this.gridData.set([]);
  }
}
